import { BookProgressDto } from './book-progress.model';
import { BookProgress } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ScopeDto } from '../scope/scope.model';
import { PersonUsesBookDto } from '../person-uses-book/person-uses-book.model';

export function mapBookProgress(
  bookProgressDto: BookProgressDto,
): BookProgress {
  return {
    id: bookProgressDto.id,
    bookId: bookProgressDto.bookId,
    chaptersCompleted: bookProgressDto.chaptersCompleted,
    totalChapters: bookProgressDto.totalChapters,
  };
}

export function mapScopesToBookProgress(scopes: ScopeDto[]): BookProgress[] {
  return scopes.reduce((bookProgresses: BookProgress[], scope: ScopeDto) => {
    if (scope.personUsesBook && scope.personUsesBook.bookProgress) {
      bookProgresses.push(mapBookProgress(scope.personUsesBook.bookProgress));
    }
    return bookProgresses;
  }, []);
}

export function mapPersonUsesBookToBookProgress(
  personUsesBooks: PersonUsesBookDto[],
): BookProgress[] {
  return personUsesBooks.reduce(
    (bookProgresses: BookProgress[], personUsesBook: PersonUsesBookDto) => {
      if (personUsesBook.bookProgress) {
        bookProgresses.push(mapBookProgress(personUsesBook.bookProgress));
      }
      return bookProgresses;
    },
    [],
  );
}
